import { Client } from '@pythnetwork/express-relay-js'

let pythClient: Client | undefined

export function makePythClient() {
  if (!pythClient) {
    pythClient = new Client(
      { baseUrl: '/api/pyth' },
      undefined, // Default WebSocket options
    )
  }
  return pythClient
}
